//import liraries
import React, { Component, useEffect, useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import { disputeHistory } from "../../../api/apiManager";
import CTiCertificateWrapper from "../../../common/CTiCertificateWrapper";

// create a component
const TripDisputeDetailsCard = (props) => {

  const [data, setData] = useState([])
  const [disputeType, setDisputeType] = useState("")
  const [disputeDate, setDisputeDate] = useState("")


  const getDisputeHistory = () => {
    let params = { txnId: props?.data?.transId,
       transactionType: props?.data?.transactionType,
     }

    console.log('-------------------transaction----------', params)
    disputeHistory(params)
      .then(res => {
        console.log('llog0-----------log--------------------log', res.disputeHistory)
        let date = res?.disputeHistory[0]?.raisedDate
        date = date.split(",")
        date = date[0]
        setDisputeDate(date)
        setData(res.disputeHistory[0])
        setDisputeType(res?.txnType)
      }).catch(() => {
      })
  }

  useEffect(() => {
    getDisputeHistory()
  }, [props])

  return (
    <View style={[styles.container, { borderColor: props.borderColor, borderWidth: props.borderWidth }]}>
      <View style={{ marginTop: 15 }}>
       
        <CTiCertificateWrapper
          keyText={"Vehicle No"}
          valueText={props?.data?.vrn}
        />
        <CTiCertificateWrapper
          keyText={"Reason"}
          valueText={data?.disputeReason}
        />  
        <CTiCertificateWrapper
          keyText={"Dispute ID"}
          valueText={data?.disputeId}
        />

        <CTiCertificateWrapper
          keyText={"Amount"}
          valueText={data?.disputeAmt}
        />
        <CTiCertificateWrapper
          keyText={"Date Raised"}
          valueText={disputeDate}
        />
        <CTiCertificateWrapper
          keyText={"Dispute Type"}
          // valueText={data?.disputeReason}
          valueText={(disputeType && disputeType === "tripInsurance") ? "Trip Insurance" : "Toll"}
        />
        <CTiCertificateWrapper
          keyText={"Status"}
          valueText={data?.status}
        />
        <CTiCertificateWrapper
          keyText={"Remarks"}
          valueText={data?.statusRemarks}
        />
        {data?.proofImage &&  
        <CTiCertificateWrapper
          keyText={"Dispute Images"}
          images={data?.proofImage}
        /> }
      </View>
    </View>
  );
};

// define your styles
const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff",
    borderRadius: 15,
    borderWidth: 1,
    borderColor: "#ff9006"
  },
});

//make this component available to the app
export default TripDisputeDetailsCard;
